import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import { GovIdProofState, govIdProofFeatureKey } from '../reducers/gov-id-proof.reducer';
import * as govIdProofState from '../reducers/gov-id-proof.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, GovIdProofState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee govId  proof SUB STATE
export const getGovIdProofState = createSelector(getMainEmployeeState, state => state[govIdProofFeatureKey]);
//#endregion

//#region Employee govId proof SUB STATE
export const getGovIdProofRequest = createSelector(getGovIdProofState, govIdProofState.getGovIdProofRequest);
export const getGovIdProofResponse = createSelector(getGovIdProofState, govIdProofState.getGovIdProofResponse);
export const getGovIdProofFailure = createSelector(getGovIdProofState, govIdProofState.getGovIdProofFailure);
//#endregion
